// Tiny global store for the in-flight tailoring run. The tailoring page keeps
// running while HIDDEN (it stays mounted across route changes — see App.tsx),
// and this store lets the floating progress pill anywhere in the app show the
// live percentage and jump the user back.

export interface TailoringRunStatus {
  active: boolean;
  progress: number;      // 0-100
  elapsedSeconds: number;
  label: string;
}

let status: TailoringRunStatus = { active: false, progress: 0, elapsedSeconds: 0, label: '' };
const listeners = new Set<(s: TailoringRunStatus) => void>();

export function setTailoringRunStatus(patch: Partial<TailoringRunStatus>): void {
  status = { ...status, ...patch };
  for (const fn of listeners) fn(status);
}

export function getTailoringRunStatus(): TailoringRunStatus {
  return status;
}

export function subscribeTailoringRunStatus(fn: (s: TailoringRunStatus) => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
